// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__Response from "./response.jsx";
import * as Subsonic__Song from "./song.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function playQueue_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.changed;
  const v$1 = x.changedBy;
  const v$2 = x.current;
  const v$3 = x.entry;
  const v$4 = x.position;
  const v$5 = x.username;
  return {
    changed: v !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"changed\""),
    changedBy: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"changedBy\""),
    current: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$2) : undefined,
    entry: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__Song.of_json, v$3) : Ppx_deriving_json_runtime.of_json_error("missing field \"entry\""),
    position: v$4 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v$4) : undefined,
    username: v$5 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$5) : Ppx_deriving_json_runtime.of_json_error("missing field \"username\"")
  };
}

function playQueue_to_json(x) {
  return {
    changed: x.changed,
    changedBy: x.changedBy,
    current: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.current),
    entry: Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__Song.to_json, x.entry),
    position: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.position),
    username: x.username
  };
}

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "ok" ? "ok" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.playQueue;
  return {
    status: tmp,
    playQueue: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(playQueue_of_json, v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"playQueue\"")
  };
}

function body_to_json(x) {
  return {
    status: "ok",
    playQueue: Ppx_deriving_json_runtime.Primitives.option_to_json(playQueue_to_json, x.playQueue)
  };
}

function of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

const $$Response = {
  playQueue_of_json: playQueue_of_json,
  playQueue_to_json: playQueue_to_json,
  body_of_json: body_of_json,
  body_to_json: body_to_json,
  of_json: of_json,
  to_json: to_json
};

function make(param) {
  const params = {};
  return Fx.Monad_syntax.let$star(Subsonic__Utils.makeRequest({
    _method: "rest/getPlayQueue",
    params: params
  }, of_json), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: param.response.playQueue
    };
  }));
}

export {
  $$Response,
  make,
}
/* No side effect */
